
export const BASE_URL_PROD = "https://oscar-parties-api-dot-oscarparty.uc.r.appspot.com";
export const BASE_URL_DEV = "http://localhost:8080";

const BASE_URL = process.env.REACT_APP_ENV === 'dev' ? BASE_URL_DEV : BASE_URL_PROD;


export const postPartyGoer = (partyGoer, token) => {
       return fetch(`${BASE_URL}/partyGoers/add`, {
              method: 'POST',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(partyGoer)
       })
              .then(response => response.json());
}

export const updatePartyGoer = (partyGoer, token) => {
       return fetch(`${BASE_URL}/partyGoers/update`, {
              method: 'PUT',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(partyGoer)
       })
              .then(response => response.json());
}

export const getPartyGoer = (email, token) => {
       return fetch(`${BASE_URL}/partyGoers/byEmail/${email}`, {
              method: 'GET',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`

              }
       })
              .then(response => response.json());
}

export const getAllNomineesAndCategories = (oscarYear, token) => {
       return fetch(`${BASE_URL}/nominees/allByCategory/${oscarYear}`, {
              method: 'GET',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
       })
              .then(response => response.json());
}

export const getCategories = () => {
       return fetch(`${BASE_URL}/nominees/allCategories`)
              .then(response => response.json());
}

export const getWinners = (oscarYear, token) => {
       return fetch(`${BASE_URL}/nominees/winners/all/${oscarYear}`,
              {
                     method: 'GET',
                     headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                     },
              })
              .then(response => response.json());
}

export const saveWinners = (winners, token) => {
       return fetch(`${BASE_URL}/nominees/winners/add`, {
              method: 'POST',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(winners)
       });
}

export const postUserPicks = (picks, token) => {
       return fetch(`${BASE_URL}/my-picks/save`, {
              method: 'POST',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(picks)
       });
}

export const getUserPicks = (email, partyId, token) => {
       return fetch(`${BASE_URL}/my-picks/${email}/${partyId}`, {
              method: 'GET',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              }
       })
              .then(response => response.json());
}

export const createParty = (party, token) => {
       return fetch(`${BASE_URL}/parties/add`, {
              method: 'POST',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(party)
       })
              .then(response => response.json());
}

export const updateParty = (party, token) => {
       return fetch(`${BASE_URL}/parties/update`, {
              method: 'PUT',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(party)
       })
              .then(response => response.json());
}


export const getPartyById = (partyId, token) => {
       return fetch(`${BASE_URL}/parties/byId/${partyId}`, {
              method: 'GET',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              }
       })
              .then(response => response.json());
}

export const getLeaderBoard = (partyId, token) => {
       return fetch(`${BASE_URL}/parties/leaderboard/${partyId}`, {
              method: 'GET',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              }
       })
              .then(response => response.json());
}
export const deleteParty = (partyId, token) => {
       return fetch(`${BASE_URL}/parties/${partyId}`, {
              method: 'DELETE',
              headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`
              }
       });
}
